/**
 * Detail bundle for a single database query (`$queryId`), matching
 * either flavor by id:
 *
 *   - a `:NamedQuery` node, or
 *   - a query-flavored `:Tag` node (`tag_system = 'db'` or
 *     `ignition_tag_type = 'query'`).
 *
 * Returns the node plus:
 *   - `database` — the `:Database` it `USES_DATABASE` (if any)
 *   - `host`     — the `:Compute` host a "register as data point" action
 *                  reads the query back through. The database mapper hangs
 *                  `HAS_DATABASE` off a `db_server` Compute (with the Ignition
 *                  gateway `NETWORKS_WITH` it) for parseable JDBC URLs, and
 *                  directly off the Ignition gateway for embedded/unparseable
 *                  ones (SQLite). We therefore prefer the owning Ignition
 *                  gateway (its http `url` drives the WebDev relay) and only
 *                  fall back to the direct `HAS_DATABASE` host.
 *   - `tables`   — every `:Table` the query `USES_TABLE`
 *
 * The `coalesce(nq, qt)` picks whichever label the id resolved to;
 * both labels carry a per-label unique constraint on `id`, so each
 * `OPTIONAL MATCH` is an index lookup.
 */
export const PLANT_QUERY_DETAIL_CYPHER = `
            OPTIONAL MATCH (nq:NamedQuery {id: $queryId})
            OPTIONAL MATCH (qt:Tag {id: $queryId})
              WHERE qt.tag_system = 'db' OR qt.ignition_tag_type = 'query'
            WITH coalesce(nq, qt) AS node
            WHERE node IS NOT NULL
            OPTIONAL MATCH (node)-[:USES_DATABASE]->(db:Database)
            OPTIONAL MATCH (db)<-[:HAS_DATABASE]-(directHost:Compute)
            OPTIONAL MATCH (db)<-[:HAS_DATABASE]-(:Compute)<-[:NETWORKS_WITH]-(gwHost:Compute)
              WHERE gwHost.compute_type = 'ignition'
            OPTIONAL MATCH (node)-[:USES_TABLE]->(tbl:Table)
            WITH node, db, directHost, gwHost, collect(distinct tbl) AS tables
            RETURN node,
                   CASE WHEN node:NamedQuery THEN 'named_query' ELSE 'query_tag' END AS kind,
                   db AS database,
                   CASE
                     WHEN directHost.compute_type = 'ignition' THEN directHost
                     WHEN gwHost IS NOT NULL THEN gwHost
                     ELSE directHost
                   END AS host,
                   tables
            LIMIT 1
          `
